module.exports = __webpack_public_path__ + "images/bannewr_d3d3514c.jpg";